if (!customElements.get('ingredients-component')) {
  class IngredientsComponent extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
    }

    connectedCallback() {
      this.triggers = this.querySelectorAll('.ingredients__trigger');
      this.panels = this.querySelectorAll('.ingredients__content');

      if (!this.triggers.length) return;

      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('mouseenter', () => this.setActive(index));
        trigger.addEventListener('focus', () => this.setActive(index));
        trigger.addEventListener('click', () => this.setActive(index));
      });
    }

    setActive(index) {
      if (index === this.activeIndex) return;

      this.activeIndex = index;

      this.triggers.forEach((trigger, i) => {
        const isActive = i === index;
        trigger.classList.toggle('ingredients__trigger--active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('ingredients__content--active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });
    }
  }

  customElements.define('ingredients-component', IngredientsComponent);
}
